import gsap from 'gsap'
import modular from 'modujs'
import { html } from './utils/environment'
import * as modules from './modules'
import globals from './globals'
import { preloader } from './preloader'

// eslint-disable-next-line new-cap
const app = new modular({
  modules,
})

window.isMobile = (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

if (window.isMobile) {
  html.classList.add('is-mobile')
} else {
  html.classList.add('is-desktop')
}
if (window.isMobile) {
  if (window.innerWidth > 1000) {
    window.isTablet = true
  }
}

window.isWindows = navigator.platform.indexOf('Win') > -1

if (window.isWindows) {
  html.classList.add('is-windows')
}

window.isIos = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
if (window.isIos) {
  html.classList.add('is-ios')
}

const init = () => {
  globals()

  app.init(app)

  html.classList.add('is-loaded')
  html.classList.remove('is-loading')
  html.classList.add('is-first-preload')
  html.classList.add('is-first-load')

  gsap.delayedCall(window.readyDelay, () => {
    html.classList.add('is-ready')
    html.classList.add('has-dom-ready')

    preloader()

    window.readyDelay = 0.3

    gsap.delayedCall(window.readyCallbackDelay, () => {
      // html.classList.add('has-dom-ready-callback')

      // html.classList.add('has-dom-animated')

      window.firstHit = false
    })
  })

  // Credits
  if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
    const args = ['%c Made with ♥ by Ensemble - https://ensemble.ooo \n Developed by Cyrille Guillaume - https://cyrilleguillaume.com', 'display: block; padding: 5px 10px; background: #141414; line-height: 40px; color: #ffffff;']
    window.console.log.apply(console, args)
  } else if (window.console) {
    window.console.log('Made with love ❤️ by Ensemble - https://ensemble.ooo — Developed by Cyrille Guillaume - https://cyrilleguillaume.com')
  }
}

window.onload = () => {
  init()
}

window.firstHit = true
window.readyDelay = 1.3
window.readyCallbackDelay = 1.2
